import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import type { ContentWithSidebarBlock } from '../types';
import { DescriptionBlocks } from '../DescriptionBlocks';
import styles from './ContentWithSidebar.module.css';
interface ContentWithSidebarProps {
  block: ContentWithSidebarBlock;
  blockId: string;
}
export function ContentWithSidebar(t0) {
  const $ = _c(14);
  const {
    block,
    blockId
  } = t0;
  const t1 = `${blockId}.main`;
  let t2;
  if ($[0] !== block.main || $[1] !== t1) {
    t2 = <div className={styles.main}><DescriptionBlocks blocks={block.main} blockIdPrefix={t1} /></div>;
    $[0] = block.main;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== block.sidebar || $[4] !== blockId) {
    let t4;
    if ($[6] !== blockId) {
      t4 = (card, index) => <section key={`${card.title}-${index}`} className={`${styles.card} ${card.accent === "blue" ? styles.cardBlue : styles.cardOrange}`} data-cms-block-id={`${blockId}.sidebar.${index}`} data-cms-field="sidebarCard"><h3 className={styles.cardTitle}>{card.title}</h3><DescriptionBlocks blocks={card.blocks} blockIdPrefix={`${blockId}.sidebar.${index}.body`} /></section>;
      $[6] = blockId;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = block.sidebar.map(t4);
    $[3] = block.sidebar;
    $[4] = blockId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <aside className={styles.sidebar} aria-label="Related category resources">{t3}</aside>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== blockId || $[11] !== t2 || $[12] !== t4) {
    t5 = <section className={styles.layout} data-cms-block-id={blockId} data-cms-field="contentWithSidebar">{t2}{t4}</section>;
    $[10] = blockId;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}